<template>
  <div>
    <Mytitle />
    <div class="forgot-password">
      <div class="header">
        <button class="back" @click="$emit('back')">返回登录</button>
        <h2>忘记密码</h2>
      </div>

      <div class="card">
        <h3>请填写以下信息进行校验</h3>
        <label>姓名</label>
        <input v-model="name" type="text" placeholder="请输入姓名" />
        <label>身份证号</label>
        <input v-model="idCard" type="text" placeholder="请输入18位身份证号" />
        <button class="btn-primary" @click="verify" :disabled="loading">校验信息</button>
        <p class="tip">我们将验证姓名与身份证号是否匹配，匹配成功后可设置新密码。</p>
        <p v-if="message" class="msg">{{ message }}</p>
      </div>

      <div class="card" v-if="validated">
        <h3>请设置新密码</h3>
        <label>新密码</label>
        <input v-model="newPassword" type="password" placeholder="请输入新密码" />
        <label>确认新密码</label>
        <input v-model="confirmPassword" type="password" placeholder="请再次输入新密码" />
        <button class="btn-primary" @click="resetByIdCard" :disabled="loading">确认重置</button>
        <p v-if="resetMessage" class="msg">{{ resetMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Mytitle from '../assets/title.vue'
import { api } from '../utils/api';
export default {
  name: 'ForgotPassword',
  components: { Mytitle },
  data() {
    return {
      name: '',
      idCard: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
      message: '',
      resetMessage: '',
      validated: false,
    };
  },
  methods: {
    async verify() {
      this.loading = true; this.message = '';
      try {
        if (!this.name || !this.idCard) { this.message = '请填写姓名与身份证号'; return; }
        const res = await api.postJson('/api/user/password/reset/verify-idcard/', { name: this.name, id_card: this.idCard });
        this.validated = true;
        this.message = res.message || '验证通过，请设置新密码';
      } catch (e) {
        this.message = e.message || '验证失败，请检查姓名与身份证号';
      } finally { this.loading = false; }
    },
    async resetByIdCard() {
      this.loading = true; this.resetMessage = '';
      try {
        if (!this.validated) { this.resetMessage = '请先完成校验'; return; }
        if (!this.newPassword || !this.confirmPassword) {
          this.resetMessage = '请填写新密码';
          return;
        }
        if (this.newPassword !== this.confirmPassword) {
          this.resetMessage = '两次输入的新密码不一致';
          return;
        }
        const res = await api.postJson('/api/user/password/reset/by-idcard/', { name: this.name, id_card: this.idCard, new_password: this.newPassword });
        this.resetMessage = res.message || '密码重置成功';
        setTimeout(() => { window.location.hash = 'login'; }, 800);
      } catch (e) {
        this.resetMessage = e.message || '重置失败，请检查姓名与身份证号';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
/* 页面容器：居中、与整体蓝色主题一致 */
.forgot-password { max-width: 980px; margin: 20px auto; padding: 0 16px; }

.header { display:flex; align-items:center; gap:12px; margin-bottom: 12px; }
.header h2 { margin: 0; color: var(--color-secondary); font-weight: var(--font-weight-bold); }
.back { padding: 6px 12px; border: 1px solid var(--color-border); background: var(--color-surface); color: var(--color-secondary); border-radius: var(--radius-sm); cursor: pointer; transition: all .2s; }
.back:hover { background: #eaf4ff; }

.card { background: var(--color-surface); border: 1px solid var(--color-border); box-shadow: var(--shadow-md); border-radius: var(--radius-md); padding: var(--space-4); max-width: 640px; margin: 0 auto 16px; }

label { display:block; margin-top:12px; color: var(--color-text-primary); font-weight: var(--font-weight-medium); }
input { width:100%; padding:10px 12px; margin-top:6px; box-sizing:border-box; border: 1px solid var(--color-border); border-radius: var(--radius-sm); background: var(--color-surface); }
input:focus { outline: 2px solid var(--color-focus); outline-offset: 2px; }

.btn-primary { margin-top:16px; padding:10px 14px; background: var(--color-primary); color:#fff; border: 1px solid var(--color-primary); border-radius: var(--radius-sm); cursor:pointer; transition: background .2s, transform .05s; width: 100%; }
.btn-primary:hover { background:#0052a3; }
.btn-primary:active { transform: scale(0.99); }
.btn-primary[disabled] { background: #99b4f0; cursor: not-allowed; }

.tip { color: var(--color-text-secondary); font-size:12px; margin-top:6px; }
.msg { margin-top:10px; color: var(--color-secondary); }
.dev { margin-top:6px; color:#c00; }
</style>
